import { render } from "./PersonPage.vue?vue&type=template&id=5f1f8837&scoped=true"
import script from "./PersonPage.vue?vue&type=script&lang=js"
export * from "./PersonPage.vue?vue&type=script&lang=js"

import "./PersonPage.vue?vue&type=style&index=0&id=5f1f8837&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1f8837"]])

export default __exports__